// src/components/PaymentWebView.tsx
import { useEffect, useRef } from "react";

type Props = {
  html: string;
  onSuccess: () => void;
  onCancel: () => void;
};

export default function PaymentWebView({ html, onSuccess, onCancel }: Props) {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data === "payment_success") {
        onSuccess();
      } else if (event.data === "payment_failed") {
        onCancel();
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [onSuccess, onCancel]);

  return (
    <iframe
      ref={iframeRef}
      srcDoc={html}
      style={{ width: "100%", height: "100%", border: "none" }}
      sandbox="allow-forms allow-scripts allow-same-origin allow-popups"
      title="payment-hpp"
    />
  );
}
